var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellSlash20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Bell-Slash",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16a2 2 0 01-3.995.15L8 16h4zM10 2a1.5 1.5 0 011.5 1.5V5h-3V3.5A1.5 1.5 0 0110 2z",
    id: "bell-details"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5c1.258 0 2.38.58 3.114 1.489L6.485 14H4v-.295l.336-.12A2.507 2.507 0 006 11.225V9a4 4 0 014-4zm3.853 2.92c.096.344.147.706.147 1.08v2.224c0 1.06.666 2.005 1.664 2.36l.336.12V14H8.486z",
    id: "Combined-Shape",
    fillOpacity: 0.35,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.125 1.17a.5.5 0 11.75.66l-15 17a.5.5 0 01-.75-.66L4.921 15H4a1 1 0 01-1-1v-.295a1 1 0 01.664-.942l.336-.12c.6-.214 1-.782 1-1.419V9a5 5 0 018.428-3.64zM14.61 7.06c.251.597.39 1.252.39 1.94v2.224c0 .637.4 1.205 1 1.419l.336.12a1 1 0 01.664.942V14a1 1 0 01-1 1H7.603l.882-1H16v-.295l-.336-.12A2.507 2.507 0 0114 11.225V9c0-.375-.051-.737-.148-1.08l.758-.86zM10 5a4 4 0 00-4 4v2.224c0 1.06-.666 2.005-1.664 2.36l-.336.12V14h1.804l6.962-7.89A3.987 3.987 0 0010 5z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSlash20);
export default __webpack_public_path__ + "static/media/bell-slash-20.5406097f.svg";
export { ForwardRef as ReactComponent };